import { STRATEGY_CHAT } from "../src/Strategies/strategyChat";
import { STRATEGY_ASSISTED_TRANSFER } from "../src/Strategies/strategyAssistedTransfer";
import { STRATEGY_DISPOSITION } from "../src/Strategies/strategyDispositon";
import { STRATEGY_MANUAL_CALL } from "../src/Strategies/strategyManualCall";
import { STRATEGY_CALL_FLOW } from "../src/Strategies/strategyCallFlow";
import { STRATEGY_ONGOING_CALL_IVR } from "../src/Strategies/strategyOngoingCallIvr";
import { SingletonSharedData } from "../src/Singleton/SingletonSharedData";
import { STRATEGY_TRANSFER_OPTION } from "../src/Strategies/strategyTransferOption";
import { STRATEGY_CALL_BAR } from "./Strategies/strategyCallBar";
import { STRATEGY_ALERTS } from "./Strategies/strategyAlerts";
import { STRATEGY_BLIND_TRANSFER } from "../src/Strategies/strategyBlindTransfers"

export const STRATEGY_MESSAGES = {
    getUnavailables: function (json) {
        if (typeof onUnavailableTypes === "function") {
            SingletonSharedData.setUnavailables(json.data);
            onUnavailableTypes(json.data);
        }
    },
    agentStatusChange: function (json) {
        if (typeof onAgentStatus === "function") {
            SingletonSharedData.setCurrentStatus(json.data.currentState);
            if (json.data.agentData) {
                SingletonSharedData.setUserId(json.data.agentData.userId);
                SingletonSharedData.setUserName(json.data.agentData.userName);
                SingletonSharedData.setUserExt(json.data.agentData.userExt);
            }
            onAgentStatus(json.data);
        }
    },
    updatedCallData: function (json) {
        let newData=SingletonSharedData.getDataCall();
        newData.CalKey=json.data.CalKey;
        newData.DataContact=json.data.DataContact;
        SingletonSharedData.setDataCall(newData);
        onDataCallUpdated(json.data);
    },
    Chat: function (json) {
        if (STRATEGY_CHAT[json.subaction]) {
            STRATEGY_CHAT[json.subaction](json);
        }
    },
    AssistedTransfer: function (json) {
        if (STRATEGY_ASSISTED_TRANSFER[json.subaction]) {
            STRATEGY_ASSISTED_TRANSFER[json.subaction](json);
        }
    },
    BlindTransfer: function (json) {
        if (STRATEGY_BLIND_TRANSFER[json.subaction]) {
            STRATEGY_BLIND_TRANSFER[json.subaction](json);
        }
    },
    TransferOption: function (json) {
        if (STRATEGY_TRANSFER_OPTION[json.subaction]) {
            STRATEGY_TRANSFER_OPTION[json.subaction](json);
        }
    },
    onUnavailableHistory: (json) => {
        if (typeof onUnavailableHistory === "function") {
            onUnavailableHistory(json.data);
        }
    },
    onCampaigns: (json) => {
        if (typeof onCampaigns === "function") {
            onCampaigns(json.data);
        }
    },
    onCallHistory: function (json) {
        if (typeof onCallHistory === "function") {
            let data = json.data;
            for (let i in data) {
                delete data[i].imageItem;
                delete data[i].imageBackItem;
            }
            onCallHistory(data);
        }
    },
    Disposition: function (json) {
        if (STRATEGY_DISPOSITION[json.subaction]) {
            STRATEGY_DISPOSITION[json.subaction](json);
        }
    },
    onCallBar: function (json) {
        if (STRATEGY_CALL_BAR[json.subaction]) {
            STRATEGY_CALL_BAR[json.subaction](json);
        }
    },
    ManualCall: function (json) {
        if (STRATEGY_MANUAL_CALL[json.subaction]) {
            STRATEGY_MANUAL_CALL[json.subaction](json);
        }
    },
    onLogin: () => {
        if (typeof onLogin === "function") {
            onLogin();
        }
    },
    onLogOut: () => {
        if (typeof onLogOut === "function") {
            SingletonSharedData.setCurrentStatus("Logout");
            SingletonSharedData.clear();
            onLogOut();
            let logoutState = { currentState: "Logout" };
            onAgentStatus(logoutState);
        }
    },
    CallFlow: function (json) {
        if (STRATEGY_CALL_FLOW[json.subaction]) {
            STRATEGY_CALL_FLOW[json.subaction](json);
        }
    },
    GetAgentID: function (json) {
        if (typeof onAgentId === "function") {
            SingletonSharedData.setUserId(json.data);
            onAgentId(json.data);
        }
    },
    GetUserName: function (json) {
        if (typeof onUsername === "function") {
            SingletonSharedData.setUserName(json.data);
            onUsername(json.data);
        }
    },
    GetExtension: function (json) {
        if (typeof onExtension === "function") {
            SingletonSharedData.setUserExt(json.data);
            onExtension(json.data);
        }
    },
    onCallEnds: (message) => {
        if (typeof onCallEnds === "function") {
            let oldData = SingletonSharedData.getDataCall();
            SingletonSharedData.setLastDataCall(oldData);
            onCallEnds(message.data);
        }
    },
    onDialingNumber: (message) => {
        if (typeof onDialingNumber === "function") {
            onDialingNumber(message.data);
        }
    },
    onPasswordUpdated: () => {
        if (typeof onPasswordUpdated === "function") {
            onPasswordUpdated();
        }
    },
    errorOnPasswordChange: (message) => {
        if (typeof errorOnPasswordChange === "function") {
            errorOnPasswordChange(message.data);
        }
    },
    onErrorPasswordUpdate: (message) => {
        if (typeof onErrorPasswordUpdate === "function") {
            onErrorPasswordUpdate(message.data);
        }
    },
    onError: (message) => {
        if (typeof onError === "function") {
            onError(message.data);
        }
    },
    remoteLoginError: (message) => {
        SingletonSharedData.setUserName("");
        if (typeof remoteLoginError === "function") {
            remoteLoginError(message.data);
        }
    },
    onCallsOnQueue: (message) => {
        if (typeof onCallsOnQueue === "function") {
            let callsQueue=SingletonSharedData.getCallsOnQueue();
            if (Object(callsQueue).length>0) {
                let acdExist=callsQueue.find(acd=> acd.acdID==message.data.acdID);
                if (acdExist) {
                    let index=callsQueue.indexOf(acdExist);
                    callsQueue.splice(index,1,message.data);
                } else {
                    callsQueue.push(message.data);
                }
            } else {
                callsQueue.push(message.data);
            }
            callsQueue.sort();
            SingletonSharedData.setCallsOnQueue(callsQueue);
            onCallsOnQueue(callsQueue);
        }
    },
    errorOnUnavailableStatus: (message) => {
        if (typeof errorOnUnavailableStatus === "function") {
            errorOnUnavailableStatus(message.data);
        }
    },
    errorOnUnavailableStatusHistory: (message) => {
        if (typeof errorOnUnavailableStatusHistory === "function") {
            errorOnUnavailableStatusHistory(message.data);
        }
    },
    errorOnCampaignsRelated: (message) => {
        if (typeof errorOnCampaignsRelated === "function") {
            errorOnCampaignsRelated(message.data);
        }
    },
    errorOnDialProcess: (message) => {
        if (typeof errorOnDialProcess === "function") {
            errorOnDialProcess(message.data);
        }
    },
    errorOnDispositionList: (message) => {
        if (typeof errorOnDispositionList === "function") {
            errorOnDispositionList(message.data);
        }
    },
    errorOnDispositionSelected: (message) => {
        if (typeof errorOnDispositionSelected === "function") {
            errorOnDispositionSelected(message.data);
        }
    },
    errorOnDispositionsPhonesList: (message) => {
        if (typeof errorOnDispositionsPhonesList === "function") {
            errorOnDispositionsPhonesList(message.data);
        }
    },
    errorOnPhoneNumbersList: (message) => {
        if (typeof errorOnPhoneNumbersList === "function") {
            errorOnPhoneNumbersList(message.data);
        }
    },
    errorOnCallHistory: (message) => {
        if (typeof errorOnCallHistory === "function") {
            errorOnCallHistory(message.data);
        }
    },
    OngoingCallIvr: function (json) {
        if (STRATEGY_ONGOING_CALL_IVR[json.subaction]) {
            STRATEGY_ONGOING_CALL_IVR[json.subaction](json);
        }
    },
    errorOnAvailableStatus: function (message) {
        if (typeof errorOnAvailableStatus === "function") {
            errorOnAvailableStatus(message.data);
        }
    },
    onTelephonyStatus: (json) => {
        if (typeof onTelephonyStatus === "function") {
            onTelephonyStatus(json.data);
        }
    },
    getAuxiliarReadys: (json) => {
        if (typeof onAuxiliarTypes === "function"){
            onAuxiliarTypes(json.data);
        }
    },
    errorGetAuxiliarReadys: (message) => {
        if (typeof errorGetAuxiliarReadys === "function") {
            errorGetAuxiliarReadys(message.data);
        }
    },
    getAuxiliarReadyStatus: (json) => {
        if (typeof onAuxiliarReadyStatus === "function"){
            onAuxiliarReadyStatus(json.data);
        }
    },
    errorPasswordAuxiliarReady: (message) => {
        if (typeof errorPasswordAuxiliarReady === "function") {
            errorPasswordAuxiliarReady(message.data);
        }
    },
    onAlerts: (json) => {
        if (STRATEGY_ALERTS[json.subaction]) {
            STRATEGY_ALERTS[json.subaction](json);
        }
    }
};



// WEBPACK FOOTER //
// ./src/strategyMessages.js